<template>
  <!-- 头部 -->
  <Layout>
    <template #header>
      <div style="font-weight: bold; font-size: 26px">四轮转向</div>
      <q-toggle
        :label="frontWheelSteeringRatio"
        v-model="frontWheelSteeringRatio"
        checked-icon="check"
        color="green"
        unchecked-icon="clear"
        false-value="关闭前轮可变传动比"
        true-value="开启前轮可变传动比"
        :disable="Math.abs(UIRx_SBW_HWAAng) > 30"
        size="lg"
      />
      <q-toggle
        :label="rearWheelAdjustmentFactor"
        v-model="rearWheelAdjustmentFactor"
        checked-icon="check"
        color="green"
        unchecked-icon="clear"
        false-value="关闭四轮转向协同控制"
        true-value="开启四轮转向协同控制"
        :disable="Math.abs(UIRx_SBW_HWAAng) > 30"
        size="lg"
      />
    </template>
    <template #default>
      <div class="row q-col-gutter-x-md full-height">
        <div class="col-5 col-xs-12 col-sm-5 full-height">
          <q-card flat bordered class="full-height column card-style">
            <q-card-section
              class="row justify-center items-center"
              style="flex: 1"
            >
              <!-- car -->
              <q-img
                :src="底盘透明_纵向_不带轮胎"
                :style="{
                  height: IMG_HEIGHT + 'px',
                  width: IMG_WIDTH + 'px',
                }"
                spinner-color="white"
                fit="contain"
              >
                <!-- 轮胎 -->
                <q-img
                  v-for="(tire, index) in tires"
                  :key="tire.name"
                  :style="{
                    position: 'absolute',
                    left:
                      tire.position.left !== undefined
                        ? tire.position.left + 'px'
                        : '',
                    top:
                      tire.position.top !== undefined
                        ? tire.position.top + 'px'
                        : '',
                    right:
                      tire.position.right !== undefined
                        ? tire.position.right + 'px'
                        : '',
                    bottom:
                      tire.position.bottom !== undefined
                        ? tire.position.bottom + 'px'
                        : '',
                    width: TIRES_WIDTH + 'px',
                    height: TIRES_HEIGHT + 'px',
                    transform: 'rotate(' + -tire.value + 'deg)',
                    // transition: 'all 0.5s ease-in-out',
                  }"
                  :src="tire.src"
                  alt="tire"
                >
                  <canvas
                    :ref="(el) => setCanvas(el, index)"
                    class="sector-shape"
                    :style="{
                      position: 'absolute',
                      top: getTop(index),
                      left: getLeft(index),
                      display: tire.value == 0 ? 'none' : '',
                    }"
                  ></canvas>
                </q-img>
                <!-- 右前车轮旁边的 div -->
                <div
                  :style="{
                    position: 'absolute',
                    left: `220px`,
                    top: `35px`,
                    width: '150px',
                    backgroundColor: 'rgba(255, 255, 255, 0.0)',
                  }"
                >
                  <p>{{ fanList[1].text }}</p>
                </div>
                <!-- 右后车轮旁边的 div -->
                <div
                  :style="{
                    position: 'absolute',
                    left: `220px`,
                    top: `330px`,
                    width: '150px',
                    backgroundColor: 'rgba(255, 255, 255, 0.0)',
                  }"
                >
                  <p>{{ fanList2[1].text }}</p>
                </div>
                <p
                  class="gauge-text"
                  :style="{
                    position: 'absolute',
                    width: '150px',
                    left: `40px`,
                    top: `250px`,
                    backgroundColor: 'rgba(255, 255, 255, 0.0)',
                  }"
                >
                  {{ `方向盘角度${Math.round(UIRx_SBW_HWAAng)}°` }}
                </p>
              </q-img>
              <q-btn
                :style="{
                  position: 'absolute',
                  right: '23px',
                  bottom: '23px',
                }"
                round
                :color="playStatus === 'play' ? 'red' : 'green-6'"
                glossy
                :icon="playStatus === 'play' ? 'pause' : 'play_arrow'"
                @click="handlePlayStatusChange"
                size="18px"
              />
            </q-card-section>
          </q-card>
        </div>
        <div class="col-7 col-xs-12 col-sm-7 right-column full-height">
          <q-card
            flat
            bordered
            class="column full-height card-style overflow-hidden"
          >
            <div class="row justify-around items-center input-row">
              <div class="col-12 col-sm-6 col-md-4 swerve">
                <div style="margin-right: 10px">前轮转向比:</div>
                <span style="font-weight: bold">{{ setOpthonsF ?? 0 }}</span>
              </div>
              <div class="col-12 col-sm-6 col-md-4 swerve">
                <div style="margin-right: 10px">后轮转向比:</div>
                <span style="font-weight: bold">{{ setOpthonsG ?? 0 }}</span>
              </div>
            </div>
            <div class="column overflow-hidden" style="flex: 1">
              <div
                class="col-4 overflow-hidden"
                style="
                  flex: 1;
                  border-top-right-radius: 10px;
                  border-top-left-radius: 10px;
                "
              >
                <DomainControlCharts
                  :max="50"
                  :min="-50"
                  :start="30"
                  :end="-30"
                  :xAxisLength="15"
                  :series="optionsF"
                  :showXAxisLabel="false"
                />
              </div>
              <div class="col-4 overflow-hidden">
                <DomainControlCharts
                  :max="30"
                  :min="-30"
                  :start="30"
                  :end="-30"
                  :xAxisLength="15"
                  :series="optionsG"
                  :showXAxisLabel="false"
                />
              </div>
              <div
                class="col-4 overflow-hidden"
                style="
                  flex: 1;
                  border-bottom-right-radius: 10px;
                  border-bottom-left-radius: 10px;
                "
              >
                <DomainControlCharts
                  :max="8"
                  :min="-8"
                  :start="4"
                  :end="-4"
                  :xAxisLength="15"
                  :series="optionsH"
                  :showXAxisLabel="true"
                />
              </div>
            </div>
          </q-card>
        </div>
      </div>
    </template>
  </Layout>
</template>

<script setup lang="ts">
import { onMounted, ref, nextTick, watch } from "vue";
import Layout from "./components/Layout.vue";
import {
  decreasingSequence,
  getDefaultSeriesData,
  optionseries1,
  optionseries2,
  optionseries3,
  PlayStatus,
} from "./helper/aws";
import useInitialize from "@/composables/domainControl/useInitialize";
import { SERVICE } from "@/services/domainControl/define";
import {
  generateMockAWSNofifyData,
  NOTIFY,
} from "@/services/domainControl/aws";
import { useQuasar } from "quasar";
import { useDomainControlStore } from "@/stores/domainControl";
import { isWeb } from "@/utils/capacitor";
import DomainControlCharts from "@/components/DomainControlCharts";
import 底盘透明_纵向_不带轮胎 from "@/assets/img/底盘透明_纵向_不带轮胎.png";
import 轮胎左 from "@/assets/img/轮胎左.png";
const IMG_HEIGHT = 550;
const CAR_HEIGHT = 1810;
const IMG_RATE = IMG_HEIGHT / CAR_HEIGHT;
const IMG_WIDTH = 813 * IMG_RATE;
const TIRES_TOP = 245 * IMG_RATE;
const TIRES_BOTTOM = 367 * IMG_RATE;
const TIRES_HEIGHT = 250* IMG_RATE;
const TIRES_WIDTH = 96 * IMG_RATE;
const TIRES_RIGHT = 76 * IMG_RATE;
const TIRES_LEFT = 90 * IMG_RATE;
// 方向盘角度
const UIRx_SBW_HWAAng = ref(0);
// 车速
const UIRx_VehSpd = ref();
// 前轮角度
const optionsF = ref(optionseries1());
// 横摆特性
const optionsG = ref(optionseries2());
// 后轮角度
const optionsH = ref(optionseries3());
// 前轮转向比
const frontWheelSteeringRatio = ref("开启前轮可变传动比");
// 后轮动态控制
const rearWheelAdjustmentFactor = ref("开启四轮转向协同控制");
// 前轮转向比
const setOpthonsF = ref();
// 后轮转向比
const setOpthonsG = ref();
const $q = useQuasar();
const playStatus = ref<PlayStatus>(isWeb ? "play" : "pause");
const domainControlStore = useDomainControlStore();
const tires = ref([
  {
    name: "左前",
    value: 0,
    error: false,
    src: 轮胎左, // 轮胎图片路径
    position: { left: TIRES_LEFT, top: TIRES_TOP }, // 轮胎在车图片中的位置
    gaugePosition: { left: -110, top: -50 },
    canvasRef: null,
  },
  {
    name: "右前",
    value: 0,
    error: false,
    src: 轮胎左,
    position: { right: TIRES_RIGHT, top: TIRES_TOP },
    gaugePosition: { right: 0, top: -50 },
    canvasRef: null,
    text: "",
  },
  {
    name: "右后",
    value: 0,
    error: false,
    src: 轮胎左,
    position: { right: TIRES_LEFT, bottom: TIRES_BOTTOM },
    gaugePosition: { right: 0, bottom: 100 },
    canvasRef: null,
    text: "",
  },
  {
    name: "左后",
    value: 0,
    error: false,
    src: 轮胎左,
    position: { left: TIRES_RIGHT, bottom: TIRES_BOTTOM },
    gaugePosition: { left: -110, bottom: 100 },
    canvasRef: null,
  },
]);
const canvases = ref([] as HTMLCanvasElement[]);
const fanList = ref([
  { angle: 0, dir: 90, text: "" },
  { angle: 0, dir: 270, text: "前轮角度0°" },
]);
const fanList2 = ref([
  { angle: 0, dir: 90, text: "" },
  { angle: 0, dir: 270, text: "后轮角度0°" },
]);
// 初始化时设置 canvas
onMounted(() => {
  nextTick(() => {
    tires.value.forEach((tire, index) => {
      const canvas = tire.canvasRef;
      if (canvas) {
        canvases.value[index] = canvas;
        createCanvas(index);
      }
    });
  });
});
// 获取顶部位置
function getTop(index: number) {
  const tire = tires.value[index];
  if (tire.name === "右前" || tire.name === "左前") {
    return `-10px`;
  } else {
    return `-10px`;
  }
}
// 获取左侧位置
function getLeft(index: number) {
  const tire = tires.value[index];
  if (tire.name === "右后" || tire.name === "左后") {
    return `-35px`;
  } else {
    return `-35px`;
  }
}
// 设置 canvas 引用
function setCanvas(el: any, index: number) {
  canvases.value[index] = el;
  nextTick(() => {
    createCanvas(index);
  });
} // 创建 canvas
function createCanvas(index: number) {
  const canvas = canvases.value[index];
  if (!canvas) {
    // console.error(`Canvas element at index ${index} is null or undefined. Skipping...`);
    return;
  }
  const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
  if (!ctx) {
    console.error(`无法获取 CanvasRenderingContext2D ${index}`);
    return;
  }
  canvas.width = 130;
  canvas.height = 100;
  // 设置 canvas 的变换
  ctx.translate(50, 50);
  ctx.lineWidth = 1;
  ctx.fillStyle = "aqua";
  ctx.strokeStyle = "aqua";
  // 根据轮胎名称选择绘制前轮或后轮角度
  const tire = tires.value[index];
  if (tire.name === "左前" || tire.name === "右前") {
    createStation(ctx, fanList.value);
  } else if (tire.name === "左后" || tire.name === "右后") {
    createStation(ctx, fanList2.value);
  }
}

// 创建扇形图案
function createStation(ctx: CanvasRenderingContext2D, fanList: any[]) {
  fanList.forEach((t) => {
    const dir = ((t.dir - t.angle / 2) * Math.PI) / 180;
    drawFan(ctx, t.angle, dir);
  });
}

// 绘制扇形和文字
function drawFan(ctx: CanvasRenderingContext2D, angle: number, dir: number) {
  ctx.save();
  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.rotate(dir);

  // 处理负角度
  const absAngle = Math.abs(angle);
  if (angle < 0) {
    const value = 360 - absAngle;
    ctx.arc(0, 0, 49, 0, (Math.PI / 180) * value, true); // 反向绘制
  } else {
    ctx.arc(0, 0, 49, 0, (Math.PI / 180) * absAngle, false); // 正向绘制
  }

  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
}
const seriesData = ref(getDefaultSeriesData());

const handleNotify = (data: DomianControl.AWSNotifyData) => {
  UIRx_SBW_HWAAng.value = data.UIRx_SBW_HWAAng;
  UIRx_VehSpd.value = Math.round(data.UIRx_VehSpd);
  setOpthonsF.value = data.UIRx_FrontGearRto;
  setOpthonsG.value = data.UIRx_RearGearRto;

  tires.value.forEach((tire) => {
    if (tire.name === "左前" || tire.name === "右前") {
      tire.value = data.UIRx_AxleStAng_FA ? data.UIRx_AxleStAng_FA : 0;
      fanList.value.map((item) => {
        item.angle = tire.value;
        if (tire.name === "左前") {
          item.text = `前轮角度${tire.value}°`;
        }
      });
    } else {
      tire.value = data.UIRx_AxleStAng_RA ? data.UIRx_AxleStAng_RA : 0;
      fanList2.value.map((item) => {
        item.angle = tire.value;
        if (tire.name === "左后") {
          item.text = `后轮角度${tire.value}°`;
        }
      });
    }
  });
  if (playStatus.value !== "play") return;
  parseSeriesData(data);
};
watch(
  () => seriesData.value,
  (newValue) => {
    const {
      // 实际横摆速度
      UIRx_ACUYawRate,
      // 前轮角度
      UIRx_AxleStAng_FA,
      // 后轮角度
      UIRx_AxleStAng_RA,
      // 原始横摆速度
      UIRx_OrgYawRate,
      UIRx_AWSFrontAngAdd,
    } = newValue;

    (optionsF.value as any)[0].data = UIRx_AxleStAng_FA;
    (optionsG.value as any)[0].data = UIRx_ACUYawRate;
    (optionsG.value as any)[1].data = UIRx_OrgYawRate;
    (optionsH.value as any)[0].data = UIRx_AxleStAng_RA;
    (optionsH.value as any)[1].data = UIRx_AWSFrontAngAdd;
  }
);
const handleSliderChange = (type: string, value: number) => {
  domainControlStore.writeOutputValue({
    [type]: value,
  });
};
watch(frontWheelSteeringRatio, (newValue, oldValue) => {
  if (newValue !== oldValue) {
    const value = newValue === "开启前轮可变传动比" ? 1 : 0;
    handleSliderChange("UITx_FrontVgrSw", value);
  }
});
watch(rearWheelAdjustmentFactor, (newValue, oldValue) => {
  if (newValue !== oldValue) {
    const value = newValue === "开启四轮转向协同控制" ? 1 : 0;
    handleSliderChange("UITx_RearCtrlSw", value);
  }
});
const parseSeriesData = (data: DomianControl.AWSNotifyData) => {
  const res = [
    "UIRx_AxleStAng_FA",
    "UIRx_ACUYawRate",
    "UIRx_OrgYawRate",
    "UIRx_AxleStAng_RA",
    "UIRx_AWSFrontAngAdd",
  ].reduce((per, key) => {
    const value = data[key];
    const curList = seriesData.value[key] || [];
    if (curList.length >= decreasingSequence.length) curList.shift();
    curList.push(value);
    per[key] = curList;
    return per;
  }, {} as DomianControl.AWSSeriesData);
  seriesData.value = res;
};
const handlePlayStatusChange = async () => {
  const value = playStatus.value === "play" ? "pause" : "play";
  if (value === "play") {
    seriesData.value = getDefaultSeriesData();
    if (!isNotifyed.value) {
      $q.loading.show();
      await startNotifications().finally(() => $q.loading.hide());
    }
    // startNotifications();
  }
  playStatus.value = value;
};
const parseOutputValue = (value: DomianControl.OutputValue) => {
  console.log("[BOWEN_LOG] 🚀 ~~ parseOutputValue ~~ value:", value);
  const { UITx_FrontVgrSw, UITx_RearCtrlSw } = value;
  frontWheelSteeringRatio.value =
    UITx_FrontVgrSw === 1 ? "开启前轮可变传动比" : "关闭前轮可变传动比";
  rearWheelAdjustmentFactor.value =
    UITx_RearCtrlSw === 1 ? "开启四轮转向协同控制" : "关闭四轮转向协同控制";
};
const { startNotifications, isNotifyed } = useInitialize({
  handleNotify,
  SERVICE_UUID: SERVICE.uuid,
  NOTIFY_UUID: NOTIFY.uuid,
  parseOutputValue: parseOutputValue,
});

// onMounted(() => {
//   setInterval(() => {
//     handleNotify(generateMockAWSNofifyData());
//   }, 50);
// });
</script>

<style scoped>
.sector-shape {
  position: absolute;
  z-index: 100;
  text-align: center;
}

.progress-style {
  position: absolute;
  top: 34vh;
  right: 19.5vw;
}

.gauge-text {
  position: absolute;
  top: 43vh;
  right: 19.5vw;
}

.q-img {
  overflow: unset;
}

.gauge-style {
  color: white;
  width: 50px;
  height: 50px;
  border: 3px solid aqua;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0;
}

.card-style {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.input-row {
  padding: 10px;
  text-align: center;
}

.swerve {
  width: 16vw;
  height: 45px !important;
  border-radius: 10px;
  background-color: rgba(112, 111, 111, 0.4);
  /* margin: auto; */
  display: flex;
  justify-content: center;
  align-items: center;
  /* line-height: 40px; */
  font-size: 18px;

  span {
    color: #fff;
  }
}

.swerve2 {
  width: 3vw;
  height: 10vh;
  margin: auto;
  line-height: 10vh;
}
</style>
